import React from 'react';
import {lazy, Suspense} from 'react';
import {Outlet} from 'react-router-dom';


// components
import {SplashScreen} from 'packages/common/components/loading-screen';
// context
import {AuthProvider} from 'packages/common/contexts/auth-context';

// ----------------------------------------------------------------------

const LoginPage = lazy(() => import('apps/dashboard/pages/auth/login/view/LoginPage'));
const TwoFactorPage = lazy(() => import('apps/dashboard/pages/auth/two-factor/view/TwoFactorPage'));
const RequestVerificationPage = lazy(() => import('apps/dashboard/pages/auth/verify-email/view/RequestVerificationPage'));
const EmailVerificationPage = lazy(() => import('apps/dashboard/pages/auth/verify-email/view/EmailVerificationPage'));
const RequestPasswordResetPage = lazy(() => import('apps/dashboard/pages/auth/reset-password/view/RequestPasswordResetPage'));
const ResetPasswordPage = lazy(() => import('apps/dashboard/pages/auth/reset-password/view/ResetPasswordPage'));

// ----------------------------------------------------------------------

const emailVerificationRoute = {
  path: 'verify-email/:token',
  element: <EmailVerificationPage />,
};

const requestVerificationRoute = {
  path: 'request-verification',
  element: <RequestVerificationPage />,
};

const requestResetPasswordRoute = {
  path: 'request-reset-password',
  element: <RequestPasswordResetPage />,
};

const resetPasswordRoute = {
  path: 'reset-password/:token',
  element: <ResetPasswordPage />,
};

const twoFactorRoute = {
  path: 'two-factor',
  element: <TwoFactorPage />,
};

const authJwt = {
  path: '',
  element: (
    <AuthProvider>
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    </AuthProvider>
  ),
  children: [
    {
      path: 'login',
      element: <LoginPage />,
    },
    twoFactorRoute,
    emailVerificationRoute,
    requestVerificationRoute,
    requestResetPasswordRoute,
    resetPasswordRoute,
  ],
};

export const authRoutes = [
  {
    path: 'auth',
    children: [authJwt],
  },
];
